import React from "react";
import {
    Box,
    Button,
    Chip,
    Divider,
    Drawer,
    Grid,
    IconButton,
    makeStyles,
    Typography,
} from "@material-ui/core";
import { Camera, Clear } from "@material-ui/icons";
import image from "../../../icons/default1.png";

type Props = {
    open: boolean;
    onClose: () => any;
};

const useStyles = makeStyles({
    list: {
        width: 386,
    },
    head: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "72px 32px 12px",
    },
});

const BuyDrawer: React.FC<Props> = (props) => {
    const classes = useStyles();
    return (
        <Drawer anchor="left" open={props.open} onClose={props.onClose}>
            <div className={classes.list}>
                <div className={classes.head}>
                    <Typography variant="h6">Story Details</Typography>
                    <IconButton onClick={props.onClose}>
                        <Clear />
                    </IconButton>
                </div>
                <Divider />
                <Box paddingY={2} paddingX={3}>
                    <Grid container spacing={2}>
                        <Grid item>
                            <img src={image} alt="" />
                        </Grid>
                        <Grid item>
                            <Typography variant="h6">
                                The Other Worlders
                            </Typography>
                            <Typography variant="subtitle2" gutterBottom>
                                5 Parts . 2.5 hours read
                            </Typography>
                            <Divider />
                            <Typography variant="subtitle2">
                                Pencil Score:
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                color="secondary"
                                gutterBottom
                            >
                                <Camera color="secondary" fontSize="small" />{" "}
                                76%
                            </Typography>
                            <Divider />
                            <Typography variant="subtitle2">
                                Engagement
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} style={{ marginTop: 8 }}>
                        <Grid item>
                            <Chip label="Action" />
                        </Grid>
                        <Grid item>
                            <Chip label="Action" />
                        </Grid>
                        <Grid item>
                            <Chip label="Action" />
                        </Grid>
                    </Grid>
                </Box>
                <Divider />
                <Box paddingY={2} paddingX={3}>
                    <Typography variant="h6" gutterBottom>
                        Story Contents
                    </Typography>
                    {[1, 2, 3, 4].map((el) => (
                        <Box
                            key={el}
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            border={1}
                            padding={2}
                            marginBottom={1}
                            borderColor="#eee"
                            borderRadius={8}
                        >
                            <Typography variant="subtitle1">Part {el}</Typography>
                            <Typography variant="subtitle2">
                                30 mins read
                            </Typography>
                        </Box>
                    ))}
                </Box>
                <Divider />
                <Box paddingY={2} paddingX={3} display="flex">
                    <Button
                        variant="contained"
                        fullWidth
                        style={{ textTransform: "none" }}
                    >
                        + Shortlist story
                    </Button>
                    <Box width={12} />
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        style={{ textTransform: "none" }}
                    >
                        Buy for ₹2,999
                    </Button>
                </Box>
            </div>
        </Drawer>
    );
};

export default BuyDrawer;
